/**
 * Both links' query key, one per organization (P12, NF5).
 *
 * Under `['arc', organizationId]` beside the ARC draft's key, because the
 * links stand behind the ARC's header buttons; a link write invalidates this
 * key and the draft's, nothing else.
 */
export const linksKey = (organizationId: string | null) =>
  ['arc', organizationId, 'links'] as const;
